import React from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Home: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          mt: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Typography variant="h2" component="h1" gutterBottom>
          Welcome to Movie Night
        </Typography>
        <Typography variant="h5" component="h2" gutterBottom color="text.secondary">
          Create watchlists and vote on movies with your friends
        </Typography>
        <Box sx={{ mt: 4 }}>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/watchlists')}
            sx={{ mr: 2 }}
          >
            View Watchlists
          </Button>
          <Button
            variant="outlined"
            size="large"
            onClick={() => navigate('/watchlists')}
          >
            Create Watchlist
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default Home; 